const $getCategory = function (category  = '') {
    if(!category) return ''
      
    let data = {
      '1': '★☆☆☆☆',
      '2': '★★☆☆☆',
      '3': '★★★☆☆',
      '4': '★★★★☆',
      '5': '★★★★★',
     '1est': '★☆☆☆☆',
     '2est': '★★☆☆☆',
     '3est': '★★★☆☆',
     '4est': '★★★★☆',
     '5est': '★★★★★',
     '1 Estrellas': '★☆☆☆☆',
     '2 Estrellas': '★★☆☆☆',
     '3 Estrellas': '★★★☆☆',
     '4 Estrellas': '★★★★☆',
     '5 Estrellas': '★★★★★',
     '*': '★☆☆☆☆',
     '**': '★★☆☆☆',
     '***': '★★★☆☆',
     '****': '★★★★☆',
     '*****': '★★★★★',

     'value': 'Económico',
     'moderate': 'Moderado',
     'deluxe': 'De Lujo',
     'deluxe-villas': 'Villas de Lujo',
     'campgrounds': 'Cabañas'
   }
   return data[ category ] ? `${data[ category ]}` : category
}
let getCategory = {
  install: (app) => {
    app.config.globalProperties.$getCategory = $getCategory
    app.provide('$getCategory', $getCategory)
  }
}

export default getCategory